import React, { useState, useEffect } from "react";
import axios from "axios";
import NavbarComponent from "./NavbarComponent";
import Footer from "./Footer";
import API_URLS from "./apiConfig";
import { useParams } from "react-router-dom";

const Leadership = () => {
  const [pagetitle, setPageTitle] = useState('Leadership');
  const [leaderships, setLeaderships] = useState([]);
  // const [loading, setLoading] = useState(true);
  // const [error, setError] = useState(null);
  const imageUrl = API_URLS.baseUrl;
  const { id } = useParams();
  const { pagename } = useParams();
  const defaultlang = API_URLS.defaultLang;

  useEffect(() => {
    axios
    .get(API_URLS.getAllDetails+`/${pagename}/${id}/${defaultlang}`)
    .then((response) => {
      setPageTitle(response.data);
      axios
      .get(API_URLS.getAllDetails+`/${response.data.another_api_link}/${defaultlang}`)
      .then((response) => {
        setLeaderships(response.data.data);
        console.log(response.data.data);
      })
      .catch((error) => {
        console.error("Error fetching menu data:", error);
      });
    })
    .catch((error) => {
      console.error("Error fetching menu data:", error);
    });
}, [pagename, id, defaultlang]);

  return (
    <>
      <NavbarComponent />
      <div className="leadership-section">
        <div className="container">
          <h2 className="universal-header">{pagetitle.title}</h2>
            <div className="testimonial-row">
              {leaderships && leaderships.map((leadership, index) => (
                <LeadershipCard
                  key={index}
                  leadership={leadership}
                  imageUrl={imageUrl}
                />
              ))}
            </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const LeadershipCard = ({ leadership, imageUrl }) => {
  const [expanded, setExpanded] = useState(false);
  const toggleText = () => setExpanded((prev) => !prev);

  const displayedText = expanded
    ? leadership.comments
    : `${leadership.comments?.substring(0, 250) ?? ""}${
        leadership.comments?.length > 250 ? "..." : ""
      }`;

  return (
    <div className="testimonial-card">
      <div className="testimonial-content">
        <img
          src={`${imageUrl}${leadership.client_image}`}
          alt={leadership.name}
          className="testimonial-image"
        />
        <div>
          <h3 className="testimonial-name">{leadership.name}</h3>
          <p className="testimonial-role">
            {leadership.designation}
            {/* {testimonial.company || "Company not available"} */}
          </p>
          <p className="testimonial-text">
            {displayedText}
            {leadership.comments?.length > 150 && (
              <button className="toggle-button" onClick={toggleText}>
                {expanded ? "See Less" : "See More"}
              </button>
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Leadership;
